(function () {

  'use strict';

  // **********************************
  //  Data that this directive needs
  // ----------------------------------
  //
  //

  function pxPrinterTableOptions(
    $timeout, $filter, toastr, $http, $interval, $document, uuid
  ) {
    return {
      restrict: 'EA',
      scope: {
        tenant: '=tenant',
        storageObject: '=storageObject',
        viewMode: '=viewMode',
        callback: '&callback',
        exit: '&exit'
      },
      templateUrl: 'app/components/printerList/printerTableOptions/printerTableOptions.template.html',
      link: function (scope, element, attrs) {

        scope.viewMode = angular.copy(scope.viewMode);

        const customOptions = [
          'Queues',
          'Status',
          'Network',
          'IpAddress',
          'Created',
          'Location',
          'Vendor',
          'GoVersion',
          'CaptureVersion',
          'Protocol',
          'Snmp',
          'MacAddress',
          'GoConfiguration',
          'SignInProfile',
          'NfcTag',
          'SerialNumber',
          'Toner',
          'CardReaders',
          'Site'
          // 'ColorSupported',
          // 'Features',
          // 'DuplexSupported',
          // 'NetworkType',
        ];

        scope.models = {
          selected: null,
          lists: { Selected: [], Options: [] }
        };

        scope.customOptionsCopy = angular.copy(scope.customOptions);

        scope.migratedOptions = [];
        scope.customAttrs = scope.viewMode.customAttrs ? scope.viewMode.customAttrs : [];

        (function () {
          migrateOptions();
        })();

        scope.$watch(() => {
          return scope.models.lists.Selected;
        }, (val1, val2) => {
          if (val1 !== val2) {
            storeSelection();
          }
        }, true);

        scope.changeViewMode = function () {
          scope.storageObject.set('printersViewMode', scope.viewMode);
          scope.callback({ viewMode: scope.viewMode });
        };

        scope.closeMenu = function () {
          scope.exit();
        };

        function migrateOptions() {
          angular.forEach(customOptions, (option) => {
            if (scope.customAttrs.indexOf(option) < 0) {
              scope.models.lists.Options.push({ label: option, caption: $filter('translate')(option) });
            }
          });

          scope.models.lists.Options = scope.models.lists.Options.sort(compare);

          angular.forEach(scope.customAttrs, (option) => {
            scope.models.lists.Selected.push({ label: option, caption: $filter('translate')(option) });
          });

        }

        function compare(a, b) {
          if (a.caption < b.caption) {
            return -1;
          }
          if (a.caption > b.caption) {
            return 1;
          }
          return 0;
        }

        // objs.sort( compare );

        function storeSelection() {
          scope.viewMode.customAttrs = scope.models.lists.Selected.map((object) => object.label);
          scope.storageObject.set('printersViewMode', scope.viewMode);
        }

      }
    };
  }

  pxPrinterTableOptions.$inject = [
    '$timeout', '$filter', 'toastr', '$http', '$interval', '$document', 'uuid'
  ];

  angular
    .module('printix-admin')
    .directive('pxPrinterTableOptions', pxPrinterTableOptions);

})();
